export default __webpack_public_path__ + "media/images/features/local_delivery/episode6/admin-373494fdf5998fb485a81499f8e81cbb.jpeg";